export const VIEW_ALL = 'view_all';
export const VIEW_LATEST_FIRST = 'view_latest_first';

// Types for unreads
export const DOWNLOADING = 'DOWNLOADING';
export const DOWNLOADED = 'DOWNLOADED';
export const NOTIFY_ONLY = 'NOTIFY_ONLY;';

// Suggested types
export const SUGGESTED_TOP_BID = 'top_bid';
export const SUGGESTED_TOP_SUBSCRIBED = 'top_subscribed';
export const SUGGESTED_FEATURED = 'featured';

// Sidebar UI
export const SIDEBAR_SUBS_DISPLAYED = 10;
